import { LiveKitRoom } from "@livekit/components-react";
import { useLiveSessionStore } from "../../../../stores/useLiveSessionStore";
// import { useUserContext } from "../../../../stores/userContext";
import { LiveKitRoomVideo } from "./LiveKitRoomVideo";
import { LiveKitRoomAudio } from "./LiveKitRoomAudio";

export const LiveKit = () => {
  // Get session data with token
  const sessionData = useLiveSessionStore((state) => state.sessionData);
  const setIsLiveKitRoomConnected = useLiveSessionStore((state) => state.setIsLiveKitRoomConnected);
  const setEngineError = useLiveSessionStore((state) => state.setEngineError);

  const isLiveKitRoomConnected = useLiveSessionStore((state) => state.isLiveKitRoomConnected);
  // Get user info
  // const { user } = useUserContext();
  // Get LiveKit server URL from environment
  const livekitUrl = import.meta.env.VITE_LIVEKIT_URL;

  return (
    <LiveKitRoom
      video={false}
      audio={true}
      token={sessionData?.livekitToken}
      serverUrl={livekitUrl}
      connectOptions={{
        autoSubscribe: true,
      }}
      connect={true}
      onConnected={() => {
        setIsLiveKitRoomConnected(true);
        setEngineError(null);
      }}
      onDisconnected={(reason) => {
        console.log("LiveKit disconnected:", reason);
        setIsLiveKitRoomConnected(false);
      }}
      onError={(error) => {
        console.error("[LiveKit] Error connecting to room:", error);
        setIsLiveKitRoomConnected(false);
        setEngineError(`LiveKit connection error: ${error.message}`);
      }}
    >
      {isLiveKitRoomConnected && <LiveKitRoomVideo />}
      <LiveKitRoomAudio />
    </LiveKitRoom>
  );
};